import React, {
  createContext,
  useContext,
  useRef,
  MutableRefObject,
  ReactNode,
} from "react";

type HeaderContextType = MutableRefObject<HTMLDivElement | null> | null;

const HeaderContext = createContext<HeaderContextType>(null);

export const useHeader = (): HeaderContextType => {
  return useContext(HeaderContext);
};

interface HeaderProviderProps {
  children: ReactNode;
}

export const HeaderProvider: React.FC<HeaderProviderProps> = ({ children }) => {
  const headerRef = useRef<HTMLDivElement | null>(null); // Use the specific type for <div>

  return (
    <HeaderContext.Provider value={headerRef}>
      {children}
    </HeaderContext.Provider>
  );
};
